var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.875 4.37793H8.125V5.62793H6.875V4.37793ZM6.875 6.87793H8.125V10.6279H6.875V6.87793ZM7.5 1.25293C4.05 1.25293 1.25 4.05293 1.25 7.50293C1.25 10.9529 4.05 13.7529 7.5 13.7529C10.95 13.7529 13.75 10.9529 13.75 7.50293C13.75 4.05293 10.95 1.25293 7.5 1.25293ZM7.5 12.5029C4.74375 12.5029 2.5 10.2592 2.5 7.50293C2.5 4.74668 4.74375 2.50293 7.5 2.50293C10.2562 2.50293 12.5 4.74668 12.5 7.50293C12.5 10.2592 10.2562 12.5029 7.5 12.5029Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ec123a9274a4a88652e728d338694ba5.svg";
export { ForwardRef as ReactComponent };